<script lang="ts" setup>
import { ref, defineExpose, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

/**
 * Эмейл, указанный на предыдущей странице
 */
const onMovementRestoreEmail = ref(route.params.email);


/**
 * Блок элемента контента
 */
 const $currentComponentWrapper = ref(null);

/**
 * Текущая высота элемента контента
 */
const currentHeightComponent = ref(null);

/**
 * К логину
 */
const toLoginPage = () => {
  router.push("/login");
};


onMounted(() => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
});

defineExpose({
  changerMethodFromComponent: toLoginPage,
  currentHeightComponent: currentHeightComponent,
});
</script>

<template>
  <div class="layout-login__body" ref="$currentComponentWrapper">
    <div class="layout-login__state-desc">
      Новый пароль успешно отправлен <br />
      на
      <a :href="`mailto:${onMovementRestoreEmail}`">{{
        onMovementRestoreEmail
      }}</a>
    </div>
  </div>
</template>
